import components from '@/components';
import { RouteRecordRaw } from 'vue-router';
import type { RouteRecord } from './route.d'
import pinia from '@/store'
import { useCommon } from "@/store/useCommon";
const storeCommon = useCommon(pinia)

export const menuList: RouteRecord[] = [
  {
    name: 'ChannelArrangement',
    path: '/channel-arrange',
    redirect: '',
    meta: {
      title: '频道编排',
      logo: require('@/assets/imgs/ic_content@2x.png')
    },
    children: null,
    component: ()=> import(/* webpackChunkName: "ChannelArrangement" */ '@/views/channelArrangement/index.vue')
  },
  {
    name: 'Spacer',
    path: '/spacer',
    redirect: '',
    meta: {
      title: '垫片设置',
      logo: require('@/assets/imgs/ic_operate@2x.png') 
    },
    children:null,
    roles: [], // 不需要角色即可访问
    component: ()=> import(/* webpackChunkName: "Spacer" */ '@/views/spacer/index.vue')
  },
  {
    name: 'StorageServer',
    path: '/storage-server',
    redirect: '',
    meta: {
      title: '存储服务器',
      logo: require('@/assets/imgs/ic_vod@2x.png') 
    },
    children: 
    [
      {
        name: 'FTP',
        path: '/storage-server/ftp',
        meta: {
          title: 'FTP/SFTP服务器',
          icon: ''
        },
        component: () => import(/* webpackChunkName: "FTP" */ '@/views/storageServer/FTP/index.vue')
      },
      {
        name: 'S3',
        path: '/storage-server/s3',
        meta: {
          title: 'S3存储',
          icon: ''
        },
        component: () => import(/* webpackChunkName: "Match" */ '@/views/storageServer/S3/index.vue')
      },
      {
        name: 'GCS',
        path: '/storage-server/gcs',
        meta: {
          title: 'GCS存储',
          icon: ''
        },
        component: () => import(/* webpackChunkName: "Match" */ '@/views/storageServer/GCS/index.vue')
      },
    ]
  },
  {
    name: 'VccConfig',
    path: '/vcc-config',
    redirect: '',
    meta: {
      title: 'VCC设置',
      logo: require('@/assets/imgs/ic_live@2x.png') 
    },
    children:null,
    roles: [], // 不需要角色即可访问
    component: ()=> import(/* webpackChunkName: "Spacer" */ '@/views/vcc/index.vue')
  },
  {
    name: 'PublishLog',
    path: '/publish-log',
    redirect: '',
    meta: {
      title: '发布日志',
      logo: require('@/assets/imgs/ic_device@2x.png') 
    },
    children:null,
    roles: [], // 不需要角色即可访问
    component: ()=> import(/* webpackChunkName: "Spacer" */ '@/views/publishLog/index.vue')
  },

]

// 这个项目不设置路由权限，如需要则注释上面的，启用下面的代码
// 获取符合 vue-router 的路由数据，对菜单数据进行平展，将具有 children 属性的对象抛弃，将 children 下的对象平展到最外层
// function getRoutesList(menuList) {
//   menuList = menuList || [];
//   // 存放处理后的数据
//   let processList = [];
//   menuList.forEach(item => {
//     if (item.hasOwnProperty('children')) {
//       // 只要配置了children 属性，无论这个属性是否有值，都认为这是父菜单，不会存进路由
//       // 做一层浅复制，为了删除 children 属性时，不影响原始数据
//       let itemCopy = Object.assign({}, item, {});
//       // 删除 itemCopy children 属性
//       delete itemCopy.children
//       // 先将父路由添加进来
//       processList.push(itemCopy);
//       // 再处理字路由
//       if (item.children && item.children.length > 0) {
//         // 递归处理
//         processList = processList.concat(getRoutesList(item.children));
//       }
//     } else {
//       // 子菜单
//       processList.push(item);
//     }
//   });
//   return processList;
// }


// function importComponent(menuList) {
//   menuList = menuList || [];
//   let newList = [];
//   newList = menuList.map(item => {
//     if (item.component) {
//       try {
//         item.component = require(`@/views/${item.component}/index.vue`).default
//       }
//       catch (ex) {
//         console.log(item.component, "页面不存在")
//       }
//     }
//     if (item.children && item.children.length > 0) {
//       // 递归处理
//       item.children = importComponent(item.children)
//     }
//     return item
//   })
//   return newList;
// }

// let cmsRoute: RouteRecord[]
// // 拿到基座发过来的路由数据
// (window as any)?.microApp?.addDataListener((data: any) => {

//   if(data.menuList && data.menuList.length>0) {
//     cmsRoute = JSON.parse(JSON.stringify(data.menuList.filter(item=> item.path==='/cms/:page*')[0].children))
//     cmsRoute = importComponent(cmsRoute)
//   }
  
// }, true)



// export const menuList: RouteRecord[] = cmsRoute